import {BaseCriteriaModel} from "./base-criteria.model";
import {Optional} from 'typescript-optional';

export class GenericDocHealthRecordQueryCriteriaClass extends BaseCriteriaModel {

  param_code?: Optional<string> = Optional.empty();
  // param_name?: string;
  // param_type?: string;
  value_string?: Optional<string> = Optional.empty();
  doc_entity_hdr_guid?: Optional<string> = Optional.empty();
  guid_branch?: Optional<string> = Optional.empty();
  // value_numeric?: string;
  // value_datetime?: string;
  // ext_created_date?: string;
  // ext_updated_date?: string;
  // ext_status?: string;

}

export class GenericDocHealthRecordCriteriaModelQuery {
  query = '';

  constructor( entityCriteriaModel: GenericDocHealthRecordQueryCriteriaClass) {
    if (!entityCriteriaModel) {
      return;
    }

    this.query += entityCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += entityCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += entityCriteriaModel.doc_entity_hdr_guid.filter(x => x !== '').map(x => '&doc_entity_hdr_guid=' + x).orElse('');
    this.query += entityCriteriaModel.guid_branch.filter(x => x !== '').map(x => '&guid_branch=' + x).orElse('');

    this.query += '&status=' + entityCriteriaModel.status;
    // this.query += '&orderBy=' + entityCriteriaModel.orderBy;
    this.query += '&order=' + entityCriteriaModel.order;
    this.query += '&offset=' + entityCriteriaModel.offset + '&limit=' + entityCriteriaModel.limit;

  }
}
